import backofficeService from '../../api/backoffice'

export default {
  getAgedParentBalances(params) {
    return backofficeService.Api().get(`report/invoice/aged-parent-balances`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  fundInvoicesFromSadaqah(data) {
    return backofficeService.Api().post('sadaqahFunding/fund', data).then(response => response.data).catch(error => { throw error })
  },
  getSadaqahSummary(params = {}) {
    return backofficeService.Api().get('sadaqahFunding/summary', { params }).then(response => response.data).catch(error => { throw error })
  },
  getSadaqahFundings(params = {}) {
    return backofficeService.Api().get('sadaqahFunding/fundings', { params }).then(response => response.data).catch(error => { throw error })
  },
  getSadaqahRecoveries(params = {}) {
    return backofficeService.Api().get('sadaqahFunding/recoveries', { params }).then(response => response.data).catch(error => { throw error })
  },
  markSadaqahReturned(id, data) {
    return backofficeService.Api().put(`sadaqahFunding/recoveries/${id}/returned`, data).then(response => response.data).catch(error => { throw error })
  },
  getSadaqahTransferBatches(params = {}) {
    return backofficeService.Api().get('sadaqahFunding/batches', { params }).then(response => response.data).catch(error => { throw error })
  },
  createSadaqahFundingBatch(data) {
    return backofficeService.Api().post('sadaqahFunding/batches/funding', data).then(response => response.data).catch(error => { throw error })
  },
  createSadaqahReturnBatch(data) {
    return backofficeService.Api().post('sadaqahFunding/batches/returns', data).then(response => response.data).catch(error => { throw error })
  },
  markSadaqahBatchMoved(id, data) {
    return backofficeService.Api().put(`sadaqahFunding/batches/${id}/moved`, data).then(response => response.data).catch(error => { throw error })
  },
  markSadaqahBatchesMoved(data) {
    return backofficeService.Api().put('sadaqahFunding/batches/moved', data).then(response => response.data).catch(error => { throw error })
  },
  updateSadaqahTransferBatch(id, data) {
    return backofficeService.Api().put(`sadaqahFunding/batches/${id}`, data).then(response => response.data).catch(error => { throw error })
  },
  balanceByDepartment(params) {
    return backofficeService.Api().get(`report/department/all`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  studentBalancesByDepartment(params = {}) {
    return backofficeService.Api().get(`report/department/student-balances`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  donationPayments(params) {
    return backofficeService.Api().get(`report/donation/payment`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getSaleByCategory(params) {
    console.log('params', params)
    return backofficeService.Api().get(`sales/category`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getInventory(params) {
    return backofficeService.Api().get(`report/inventory/stock`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getAvalibaleSerial(params) {
    return backofficeService.Api().get(`report/inventory/availableSerial`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getProduct(params) {
    return backofficeService.Api().get(`sales/product`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getAttendanceReport(params) {
    return backofficeService.Api().get(`attendance/bydate`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })

	},
  getSubscriptionGap(params) {
    return backofficeService.Api().get(`report/subscription-gap`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
	},
  getStudentOpenInvoice(params) {
    return backofficeService.Api().get(`report/student/open-invoice`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  }
}
